import { Icon, StatusIcon } from '../../ui/icons';
import { AIAvatar, Avatar, Kbds } from '../../ui/primitives';

// 登录页右侧：缓慢漂浮的产品界面（设计稿 25h）。
// 打字中的回复、读数刻度在增长、收件箱逐条高亮、三句介绍轮播。纯装饰，读屏软件跳过。

const CAPTIONS = ['AI 按昨天的计划预填，员工只改几句', '写得含糊的地方，AI 追问一句', '主管每天只看 ≤ 5 条需要出手的事'];

export function Showcase() {
  return (
    <div className="sc" aria-hidden="true">
      <div className="sc-stage">
        {/* 我的日报 */}
        <div className="sc-float" style={{ left: 0, top: 0, animation: 'wsDrift 10s ease-in-out infinite' }}>
          <div className="sc-card" style={{ width: 520 }}>
            <div className="sc-bar">
              <span>我的日报 › 10月3日</span>
              <span style={{ color: 'var(--text-4)' }}>已自动保存</span>
            </div>
            <div style={{ padding: '18px 18px 8px' }}>
              <div style={{ fontSize: 20, fontWeight: 500, letterSpacing: '-0.012em', color: 'var(--text-1)' }}>10月3日 周五</div>
              <div className="row" style={{ marginTop: 6, gap: 6, fontSize: 11, color: 'var(--text-4)' }}>
                <span style={{ width: 5, height: 5, borderRadius: '50%', background: 'var(--text-3)' }} />
                AI 已根据昨日计划预填 · 3 个项目
              </div>
            </div>
            <div style={{ padding: '0 4px' }}>
              <div className="sc-row">
                <StatusIcon status="progress" size={12} />
                <span className="code">PRJ-12</span>
                <span className="t">剩余 2 台明早下线，本周无异常停机。</span>
              </div>
              <div className="sc-row">
                <StatusIcon status="blocked" size={12} />
                <span className="code">PRJ-07</span>
                <span className="t">
                  继续<span style={{ color: 'var(--text-1)', textDecoration: 'underline dashed var(--text-3)', textUnderlineOffset: 4 }}>等 TÜV 回复</span>，暂无新进展。
                </span>
                <span style={{ fontSize: 11, color: 'var(--text-3)' }}>1 条追问</span>
              </div>
            </div>
            <div className="sc-ask">
              <div className="row" style={{ gap: 8, fontSize: 12, color: 'var(--text-1)' }}>
                <AIAvatar size={14} />
                AI 追问
              </div>
              <div style={{ margin: '4px 0 0 22px', fontSize: 13, lineHeight: 1.6, color: 'var(--text-2)' }}>具体在等哪份材料？需要谁推动？</div>
              <div className="row" style={{ margin: '10px 0 0 22px', gap: 8, fontSize: 13, color: 'var(--text-1)' }}>
                <Avatar initial="张" size={16} />
                <span className="sc-type">缺德语版安装手册，李经理周二前给到</span>
                <span className="sc-caret" />
              </div>
            </div>
            <div style={{ padding: '8px 4px 14px' }}>
              <div className="sc-row">
                <StatusIcon status="progress" size={12} />
                <span className="code">PRJ-15</span>
                <span className="t">压差收敛到 12mV 以内，明天进高低温验证。</span>
              </div>
            </div>
          </div>
        </div>

        {/* 读数格 */}
        <div className="sc-float" style={{ left: 560, top: -40, animation: 'wsDrift2 12s ease-in-out infinite' }}>
          <div className="sc-card" style={{ width: 300 }}>
            <div style={{ padding: '16px 18px 18px' }}>
              <div className="row" style={{ gap: 8, fontSize: 12 }}>
                <StatusIcon status="progress" size={12} />
                <span className="c1">iCharger 量产</span>
                <span className="c4">PRJ-12</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'baseline', marginTop: 18 }}>
                <span style={{ fontSize: 56, fontWeight: 300, letterSpacing: '-0.045em', lineHeight: 0.9, color: 'var(--text-1)' }}>48</span>
                <span style={{ fontSize: 18, fontWeight: 300, color: 'var(--text-4)', marginLeft: 4 }}>/50 台</span>
              </div>
              <div className="sc-ticks">
                <div />
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 12, fontSize: 11, color: 'var(--text-4)' }}>
                <span>老化测试 · 10月8日</span>
                <span className="c3">5 天</span>
              </div>
            </div>
          </div>
        </div>

        {/* 收件箱 */}
        <div className="sc-float" style={{ left: 540, top: 250, animation: 'wsDrift 14s ease-in-out infinite' }}>
          <div className="sc-card" style={{ width: 400 }}>
            <div className="sc-bar">
              <span>收件箱</span>
              <span style={{ color: 'var(--text-4)' }}>今天 3 条需要处理</span>
            </div>
            <div style={{ padding: '6px 0 8px' }}>
              {[
                { s: 'blocked' as const, t: '德国 EMS 认证阻塞 3 天', who: '张工', delay: '0s' },
                { s: 'blocked' as const, t: 'iBMS 4.0 交付日期第 3 次后移', who: '陈工', delay: '3s' },
                { s: 'todo' as const, t: '50kW 逆变器 CE 认证 5 天未启动', who: '王工', delay: '6s' },
              ].map((r) => (
                <div key={r.t} className="sc-ibrow" style={{ animationDelay: r.delay }}>
                  <StatusIcon status={r.s} size={12} />
                  <span className="flex1 ellipsis c1">{r.t}</span>
                  <span className="c3">{r.who}</span>
                </div>
              ))}
            </div>
            <div className="row" style={{ alignItems: 'flex-start', gap: 10, padding: '10px 16px 14px', borderTop: '1px solid var(--line)' }}>
              <span style={{ marginTop: 2 }}>
                <AIAvatar size={14} />
              </span>
              <span style={{ fontSize: 12, lineHeight: 1.6, color: 'var(--text-2)' }}>卡点不在 TÜV，而在德语版安装手册——这份材料目前没人认领。</span>
            </div>
          </div>
        </div>

        {/* ⌘K 命令面板 */}
        <div className="sc-float" style={{ left: 40, top: 360, animation: 'wsDrift2 11s ease-in-out infinite' }}>
          <div className="sc-card" style={{ width: 340, background: 'var(--bg-overlay)' }}>
            <div className="row" style={{ height: 40, gap: 10, padding: '0 14px', borderBottom: '1px solid var(--stroke-panel)', fontSize: 13, color: 'var(--text-4)' }}>
              <Icon name="search" size={14} />
              <span className="flex1">跳到项目雷达</span>
              <Kbds keys={['G', 'R']} />
            </div>
            <div style={{ padding: 6 }}>
              <div className="row" style={{ gap: 10, height: 30, padding: '0 8px', borderRadius: 6, fontSize: 12, color: 'var(--text-1)', background: 'var(--bg-selected)' }}>
                <Icon name="doc" size={14} />
                <span className="flex1">写今天的日报</span>
                <Kbds keys={['C']} />
              </div>
              <div className="row" style={{ gap: 10, height: 30, padding: '0 8px', borderRadius: 6, fontSize: 12, color: 'var(--text-1)' }}>
                <Icon name="inbox" size={14} />
                <span className="flex1">打开收件箱</span>
                <Kbds keys={['G', 'I']} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="sc-copy">
        <span style={{ fontSize: 12, color: 'var(--text-4)' }}>Wattsonic 日报</span>
        <div className="sc-headline">
          把日报写成
          <br />
          团队的工作记忆
        </div>
        <div className="sc-caps">
          {CAPTIONS.map((t, i) => (
            <div key={t} style={{ animationDelay: `${i * 4}s` }}>
              {t}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
